var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      attrs: {
        "class-name": "fill-height"
      }
    },
    [
      _c("gg-card-header", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
      _c(
        "gg-card-text",
        [
          _vm.type === "month"
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pb-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _vm._v(" Reporting Period: "),
                      _c("b", [_vm._v(_vm._s(_vm.reportingPeriod))])
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pb-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _vm._v(" Signups this Period: "),
                      _c("b", [_vm._v(_vm._s(_vm.overview.signUps))])
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pb-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _vm._v(" Payout per Signup: "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.moneyFormat(_vm.overview.payout)))
                      ])
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _vm._v(" Earnings this Period: "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.moneyFormat(_vm.overview.earnings)))
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }